import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";

if(environment.isProduction) {
  Sentry.init({
    dsn: "https://1e56110215394188a9f5517b7414e1c7@o4508958440751104.ingest.de.sentry.io/4508964031103056",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "localhost", 
      new RegExp(`^${environment.clickkerAuth.api.url}`), 
      new RegExp(`^${environment.clickkerCloud.api.url}`), 
      new RegExp(`^${environment.clickkerWatcher.api.url}`), 
      new RegExp(`^${environment.clickkerWatcher.webSocket.url}`)],
  });
  
  Sentry.setTag("tenant ID", "Unknown");
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
